import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Header } from '../components/Header';
import { CTASection } from '../components/CTASection';
import { DemoModal } from '../components/DemoModal';
import { Footer } from '../components/Footer';
import { Store, Coffee, UtensilsCrossed, Building2 } from 'lucide-react';
export function SolutionsPage() {
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);
  const solutions = [{
    icon: Store,
    title: 'Independent Restaurants',
    description: "Scale your passion with professional-grade financial tools that don't require a finance degree.",
    benefits: ['Daily P&L tracking', 'Food cost optimization', 'Labor management']
  }, {
    icon: Coffee,
    title: 'Cafés & Bakeries',
    description: 'Master high-volume, low-margin operations with precision inventory and waste tracking.',
    benefits: ['Waste reduction', 'Ingredient level tracking', 'Shift performance']
  }, {
    icon: UtensilsCrossed,
    title: 'Fine Dining',
    description: 'Protect your margins while maintaining the highest standards of service and quality.',
    benefits: ['High-value inventory security', 'Wine cellar management', 'Labor cost control']
  }, {
    icon: Building2,
    title: 'Multi-Unit Groups',
    description: 'Consolidate operations across locations and identify top performers with ease.',
    benefits: ['Inter-company transfers', 'Consolidated reporting', 'Regional benchmarking']
  }];
  return <main className="min-h-screen bg-stark-white" data-id="element-218">
      <Header onOpenDemo={() => setIsDemoModalOpen(true)} data-id="element-219" />

      <section className="pt-32 pb-20 bg-midnight-navy text-stark-white" data-id="element-220">
        <div className="max-w-7xl mx-auto px-6" data-id="element-221">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="max-w-3xl" data-id="element-222">
            <h1 className="text-5xl md:text-6xl font-manrope font-bold mb-6" data-id="element-223">
              Tailored Solutions
            </h1>
            <p className="text-xl text-stark-white/70 leading-relaxed" data-id="element-224">
              Whether you're a single neighborhood gem or a growing national
              group, ROI adapts to your unique operational needs.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-24" data-id="element-225">
        <div className="max-w-7xl mx-auto px-6 space-y-24" data-id="element-226">
          {solutions.map((solution, idx) => <motion.div key={solution.title} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className={`flex flex-col md:flex-row gap-12 items-center ${idx % 2 === 1 ? 'md:flex-row-reverse' : ''}`} data-id="element-227">
              <div className="flex-1 space-y-6" data-id="element-228">
                <div className="w-16 h-16 bg-accent-red rounded-2xl flex items-center justify-center shadow-xl shadow-accent-red/20" data-id="element-229">
                  <solution.icon className="w-8 h-8 text-stark-white" data-id="element-230" />
                </div>
                <h2 className="text-4xl font-manrope font-bold text-midnight-navy" data-id="element-231">
                  {solution.title}
                </h2>
                <p className="text-lg text-midnight-navy/60 leading-relaxed" data-id="element-232">
                  {solution.description}
                </p>
                <ul className="space-y-3" data-id="element-233">
                  {solution.benefits.map(benefit => <li key={benefit} className="flex items-center gap-3 text-midnight-navy/80 font-medium" data-id="element-234">
                      <div className="w-1.5 h-1.5 bg-accent-red rounded-full" data-id="element-235" />
                      {benefit}
                    </li>)}
                </ul>
              </div>
              <div className="flex-1 w-full aspect-video bg-cool-gray rounded-2xl border border-gray-200 shadow-inner flex items-center justify-center" data-id="element-236">
                <span className="text-midnight-navy/20 font-manrope font-bold text-2xl uppercase tracking-widest" data-id="element-237">
                  Solution Preview
                </span>
              </div>
            </motion.div>)}
        </div>
      </section>

      <CTASection onOpenDemo={() => setIsDemoModalOpen(true)} data-id="element-238" />
      <Footer data-id="element-239" />
      <DemoModal isOpen={isDemoModalOpen} onClose={() => setIsDemoModalOpen(false)} data-id="element-240" />
    </main>;
}